import { connect } from "react-redux"
import React, { Component } from 'react';
import './Common.css';
import './LinkAccount.css';
import { changeTextInput, signMessage, changePageContext, linkAccountPageVerification, navigate } from "../actions/betActions"
import loading from '../loading2.gif';

const stateMap = (store) => {
    return {
        textInputData: store.bet.textInputData,
        ethAccount: store.bet.authentication.ethAccount,
        pageContext: store.bet.pageContext,
        authentication: store.bet.authentication
    };
};
class LinkAccount extends Component {
    constructor(props) {
      super(props);

        // This binding is necessary to make `this` work in the callback
        this.changeTextInput = this.changeTextInput.bind(this);
        this.signMessage = this.signMessage.bind(this);
        this.verifyTweet = this.verifyTweet.bind(this);
        this.nextStep = this.nextStep.bind(this);
        this.prevStep = this.prevStep.bind(this);
        this.verifyAuth = this.verifyAuth.bind(this);
        this.navigateToSummary = this.navigateToSummary.bind(this);
        this.navigateToProposeBet = this.navigateToProposeBet.bind(this);
        this.getContext = this.getContext.bind(this);
    }

    componentDidMount() {
        this.interval = setInterval(this.verifyAuth, 500);
    }
    
    componentWillUnmount() {
        clearInterval(this.interval);
    }

    getContext() {
        let { LINK_ACCOUNT_CONTEXT={} } = this.props.pageContext;
        let { step="USERNAME", twitterVerified=false, twitterVerifiedIsSlow=false, tweetId="", addressVerified=false } = LINK_ACCOUNT_CONTEXT;

        return { step, twitterVerified, twitterVerifiedIsSlow, tweetId, addressVerified };
    }

    verifyAuth() {
        let { LINK_ACCOUNT={} } = this.props.textInputData;
        let { username="" } = LINK_ACCOUNT;
        let context = this.getContext();

        if(context.step === "VERIFYING_TWITTER" && !context.twitterVerified && username && username !== "" && /^[a-zA-Z0-9_]+$/i.test(username) && this.props.ethAccount !== "") {
            this.props.dispatch(linkAccountPageVerification("username", { username: username, address: this.props.ethAccount }));
        }
    }

    changeTextInput(event) {
        this.props.dispatch(changeTextInput(event.target.name, event.target.value, "LINK_ACCOUNT"));
    }

    signMessage(event) {

        let { LINK_ACCOUNT={} } = this.props.textInputData;
        let { username="" } = LINK_ACCOUNT;

        let { LINK_ACCOUNT_CONTEXT={} } = this.props.pageContext;
        let { tweetId="" } = LINK_ACCOUNT_CONTEXT;

        this.props.dispatch(signMessage(username, this.props.ethAccount, tweetId));
    }

    verifyTweet(event) {

    }

    navigateToSummary() {
        this.props.dispatch(navigate("SUMMARY", this.props.authentication));
    }

    navigateToProposeBet() {
        this.props.dispatch(navigate("PROPOSE_BET", this.props.authentication));
    }

    nextStep(event) {
        let { hasMetamask=false, twoWayExists=false, tweetId="" } = this.props.authentication;
        let context = this.getContext();

        let newTweetId = context.tweetId;
        if(newTweetId === "") {
            newTweetId = tweetId;
        }

        let nextStep = "USERNAME";
        if(context.step === "USERNAME") { 

            if(hasMetamask) {
                nextStep = "CONNECT_TWITTER"; 
            }
            else {
                nextStep = "REQUEST_METAMASK"; 
            }
        }
        else if(context.step === "REQUEST_METAMASK") { 
            
            if(twoWayExists) {
                nextStep = "CONNECT_ETHEREUM"; 
            }
            else {
                nextStep = "CONNECT_TWITTER"; 
            }
        }
        else if(context.step === "CONNECT_TWITTER") { nextStep = "VERIFYING_TWITTER"; }
        else if(context.step === "VERIFYING_TWITTER") { nextStep = "CONNECT_ETHEREUM"; }

        this.props.dispatch(changePageContext({step: nextStep, twitterVerified: (context.twitterVerified || twoWayExists), addressVerified: context.addressVerified, tweetId: newTweetId}, "LINK_ACCOUNT"));
    }
  
    prevStep(event) {
        let context = this.getContext();
        let { twitterVerified=false, addressVerified=false } = context;

        let prevStep = "USERNAME";
        if(context.step === "CONNECT_ETHEREUM") { prevStep = "VERIFYING_TWITTER"; addressVerified = false; }
        else if(context.step === "VERIFYING_TWITTER") { prevStep = "CONNECT_TWITTER"; twitterVerified = false; addressVerified = false; }
        else if(context.step === "REQUEST_METAMASK") { prevStep = "USERNAME"; twitterVerified = false; addressVerified = false; }
        else if(context.step === "CONNECT_TWITTER") { prevStep = "USERNAME"; twitterVerified = false; addressVerified = false; }

        this.props.dispatch(changePageContext({step: prevStep, twitterVerified:twitterVerified, addressVerified:addressVerified}, "LINK_ACCOUNT"));
    }

    allowNextStep() {
        let { LINK_ACCOUNT={} } = this.props.textInputData;
        let { username="" } = LINK_ACCOUNT;
        let context = this.getContext();

        let { hasMetamask=false } = this.props.authentication;

        if(context.step === "USERNAME") {
            if(username && username !== "" && /^[a-zA-Z0-9_]+$/i.test(username)) {
                return true;
            }
            return false;
        }
        else if(context.step === "REQUEST_METAMASK") {
            if(hasMetamask) {
                return true;
            }
            return false;
        }
        else if(context.step === "VERIFYING_TWITTER") {
            if(context.twitterVerified) {
                return true;
            }
            return false;
        }
        else if(context.step === "CONNECT_ETHEREUM") {
            if(context.twitterVerified && context.addressVerified) {
                return true;
            }
            return false;
        }

        return true;
    }

    allowPrevStep() {
        let context = this.getContext();
        if(context.step === "USERNAME") {
            return false;
        }

        return true;
    }

    showDone() {
        let context = this.getContext();
        if(context.step === "CONNECT_ETHEREUM") {
            return true;
        }

        return false;
    }

    render() {  

        let { LINK_ACCOUNT={} } = this.props.textInputData;
        let { username="", tweetURL="" } = LINK_ACCOUNT;
        let context = this.getContext();

        let allowNextStep = this.allowNextStep();
        let allowPrevStep = this.allowPrevStep();
        let showDone = this.showDone();

      return (
          <div>
            <div className="dialog">
                
                {allowPrevStep ? (
                    <button className="btn posTopLeft" onClick={this.prevStep}>&larr;</button>
                ) : (
                    <button className="btn posTopLeft disabled">&larr;</button>
                )}
                
                {allowNextStep ? (showDone ? (
                    <button className="btn posTopRight" onClick={this.navigateToSummary}>Done</button>
                ) : (
                    <button className="btn posTopRight" onClick={this.nextStep}>Next</button>
                )) : (
                    <button className="btn posTopRight disabled">{showDone ? "Done" : "Next" }</button>
                )}

                <div className={context.step === "USERNAME" ? "" : "hide"}>
                    <div className="padBottom"></div>
                    <div className="labelInputGroup moveTop40">What is your Twitter username?</div>
                    <div><input autoComplete="off" placeholder="Twitter username" type="text" className="twitterUsernameTextbox moveTop20" name="username" value={username} onChange={this.changeTextInput} /></div>
                    <div className="labelInput moveTop20">Don't have a Twitter account? Sign up for one <a target="_blank" className="bluelink" href={"https://twitter.com/signup"}>here</a>.</div>
                </div>
                <div className={context.step === "REQUEST_METAMASK" ? "" : "hide"}>
                    <div className="padBottom"></div>
                    <div className="labelInputGroup moveTop40">Do you have an Ethereum wallet?</div>
                    <div className="labelInput moveTop20">Ethbet links an Ethereum wallet to your Twitter account for making bets.  Please sign in to an Ethereum wallet such as Metamask or Mist.</div>
                    <div className="" ><a className="btn moveTop20" href={"https://metamask.io/"}>Install Metamask</a></div>
                    <div className="labelInput moveTop20">Press "Next" once you've signed in to your Ethereum wallet.</div>
                </div>
                <div className={context.step === "CONNECT_TWITTER" ? "" : "hide"}>
                    <div className="padBottom"></div>
                    <div className="labelInputGroup moveTop40">Connect your Twitter account</div>
                    <div className="" ><a className="btn moveTop20" href={"https://twitter.com/intent/tweet?text=%23ethbet%20" + this.props.ethAccount}>Click to tweet</a></div>
                    <div className="labelInput moveTop20">Tweet a message with "#ethbet {this.props.ethAccount}" to prove you own @{username}. You may do this manually or with the above button.</div>
                </div>
                <div className={context.step === "VERIFYING_TWITTER" ? "" : "hide"}>
                    <div className="padBottom"></div>
                    <div className="labelInputGroup moveTop40">Verifying your Twitter account</div>
                    {context.twitterVerified ? (
                        <div>
                            <div className="labelInput moveTop20">Your Twitter account has been successfully verified{ 
                                context.tweetId !== "" && username !== "" ? 
                                (<span> using <a target="_blank" className="bluelink" href={"https://twitter.com/" + username + "/status/" + context.tweetId}>this tweet</a></span>)
                                : "" }!</div>
                            <div className="labelInput moveTop20">Click "Next" to continue.</div>
                        </div>
                    ) : (
                        <div>
                            <div className="labelInput moveTop20">We are checking Twitter and waiting for your tweet to appear.</div>
                            <div className="moveTop20"><img src={loading} className="loadIcon" alt="loading" /></div>
                            {context.twitterVerifiedIsSlow ? (
                                <div>
                                    <div className="labelInput moveTop20">Paste a link to your tweet below if verification does not complete quickly.</div>
                                    <div><input placeholder="URL of tweet" type="text" className="textInput widthDialogInput moveTop20" name="tweetURL" value={tweetURL} onChange={this.changeTextInput} /></div>
                                    <div><button className="btn moveTop20" onClick={this.verifyTweet}>Verify tweet</button></div>
                                </div>
                            ) : ""}
                        </div>
                    )}                    
                </div>
                <div className={context.step === "CONNECT_ETHEREUM" ? "" : "hide"}>
                    <div className="padBottom"></div>
                    <div className="labelInputGroup moveTop40">Connect your Ethereum account</div>
                    {context.twitterVerified && context.addressVerified ? (
                        <div>
                            <div className="labelInput moveTop20">Congratulations, your Twitter account @{username} is now linked to your Ethereum address {this.props.ethAddress}.  You can now propose and accept bets.</div>
                            <div><button className="btn moveTop20" onClick={this.navigateToSummary}>View your bets</button><button className="btn moveTop20 moveLeft20" onClick={this.navigateToProposeBet}>Propose a bet</button></div>
                        </div>
                    ) : (
                        <div>
                            <div className="moveTop20"><button className="btn" onClick={this.signMessage}>Sign message as proof</button></div>
                            <div className="labelInput moveTop20">Make sure you're logged in to your Ethereum account (such as Metamask), and click the above button.</div>
                        </div>
                    )}
                </div>                 
            </div>
          </div>
      );
    }
  }
  
  export default connect(stateMap)(LinkAccount);



// WEBPACK FOOTER //
// ./src/components/LinkAccount.js